import React from 'react';

const items = ['METADATA EDITOR', 'REKORDBOX SYNC', 'KEY DETECTION', 'TAG CLEANER', 'LIBRARY MANAGER', 'BATCH PROCESSOR'];

export default function Marquee() {
  return (
    <div data-testid="marquee-section" style={{ padding: '14px 0', borderTop: '1px solid rgba(255,255,255,0.04)', borderBottom: '1px solid rgba(255,255,255,0.04)', overflow: 'hidden' }}>
      <div style={{ display: 'flex', animation: 'mq 40s linear infinite', width: 'max-content' }}>
        {[...items, ...items, ...items, ...items].map((t, i) => (
          <span key={i} style={{ fontFamily: 'var(--mono)', fontSize: 11, fontWeight: 500, letterSpacing: '0.15em', color: '#3F3F46', padding: '0 24px', whiteSpace: 'nowrap' }}>{t}</span>
        ))}
      </div>
      <style>{`@keyframes mq{0%{transform:translateX(0)}100%{transform:translateX(-25%)}}`}</style>
    </div>
  );
}
